import { Injectable } from "@angular/core";
import { HttpClientService } from "@/providers/services/http-client.service";
import { UsuarioLogin } from "@/providers/models/usuarioLogin";
import { UpdatePasswordRequest } from "@/providers/models/usuario-update-senha";

@Injectable({
    providedIn: "root",
})
export class UserLoginService {
    constructor(private httpClient: HttpClientService) { }

    public cadastrarUserLogin(model: UsuarioLogin): Promise<UsuarioLogin> {
        return this.httpClient.post(`/UsuarioLogin`, `/cadastrar`, model);
    }

    public updateUserLogin(
        model: UsuarioLogin,
        isProfile: boolean
    ): Promise<UsuarioLogin> {
        return this.httpClient.put(
            `/UsuarioLogin`,
            `/atualizar/${isProfile}`,
            model
        );
    }

    public activeDeactiveUserLogin(model: any): Promise<UsuarioLogin> {
        return this.httpClient.put(`/UsuarioLogin`, `/ativar/inativar`, model);
    }

    public updatePasswordUser(model: UpdatePasswordRequest): Promise<boolean> {
        return this.httpClient.put("/UsuarioLogin", `/atualizar/senha`, model);
    }
}
